import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

const baseBullets = [
    'See your best offers',
    'Check your eligibility',
    'Protect your credit score',
]

const heroData: Record<
    CreditCardProductCategory,
    {
        bullets: string[]
        title: string
    }
> = {
    ['BalanceTransfer']: {
        title: 'Compare balance transfer credit cards',
        bullets: ['Search balance transfer credit cards', ...baseBullets],
    },

    ['BestCards']: {
        title: 'Compare credit cards',
        bullets: ['Compare credit cards', ...baseBullets],
    },

    ['Cashback']: {
        title: 'Compare cashback credit cards',
        bullets: ['Compare cashback credit cards', ...baseBullets],
    },

    ['Combined']: {
        title: 'Compare balance transfer and purchase credit cards',
        bullets: [
            'Compare balance transfer and purchase credit cards',
            ...baseBullets,
        ],
    },

    ['PoorCredit']: {
        title: 'Compare credit cards for bad credit',
        bullets: [
            'Compare credit cards for poor credit',
            `See your best offers (38.4% APR representative variable)`,
            'Check your eligibility',
            'Protect your credit score',
        ],
    },

    ['Purchase']: {
        title: 'Compare 0% purchase credit cards',
        bullets: ['Search 0% purchase credit cards', ...baseBullets],
    },

    ['Rewards']: {
        title: 'Compare rewards credit cards',
        bullets: ['Compare rewards credit cards', ...baseBullets],
    },

    ['Travel']: {
        title: 'Compare travel credit cards',
        bullets: ['Compare travel credit cards', ...baseBullets],
    },
}

export default heroData
